import styled from 'styled-components';

export const Note = styled.div`
  width: 90%;
  margin: 0 auto;
  margin-top: 30px;
`;
